/* eslint-disable react/no-array-index-key */
import { FC, CSSProperties } from 'react';

type TableSkeletonProps = {
  rows: number;
  columns?: number;
  showSubHeader?: boolean;
  cardInner?: boolean;
  height?: string | number;
};

const TableSkeleton: FC<TableSkeletonProps> = ({
  rows,
  columns = 4,
  showSubHeader = true,
  cardInner = true,
  height,
}) => {
  const totalColumns = Math.max(columns, 3);

  const containerStyle: CSSProperties = height
    ? { height, overflowY: 'auto' }
    : {};

  return (
    <div
      className={`${cardInner ? 'card-inner w-100' : ''}`}
      style={containerStyle}
    >
      <div className="placeholder-glow text-left">
        <span className="placeholder col-12 h-40px mb-3 d-block" />

        {showSubHeader && (
          <span className="placeholder col-12 h-30px mb-3 d-block" />
        )}

        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            className="d-flex justify-content-between align-items-center mb-3"
            key={`table-skeleton-row-${rowIndex}`}
          >
            {Array.from({ length: totalColumns }).map((__, colIndex) => (
              <span
                key={`table-skeleton-cell-${rowIndex}-${colIndex}`}
                className={`placeholder ${
                  colIndex === 0 ? 'col-3' : 'col-2'
                } h-25px`}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeleton;
